import { Pipe, PipeTransform } from '@angular/core';
import _ from 'lodash';

@Pipe({
   name: 'stringToNumber',
})
export class StringToNumberPipe implements PipeTransform {
   transform(value: string): number {
      const conversationResult = Number(value);
      if (_.isNaN(conversationResult)) {
         return 0;
      }
      return conversationResult;
   }
}
